import React from "react";

export default function GalleryLightbox({
  activeItem,
  filteredItems,
  onClose,
  onPrev,
  onNext,
  onTouchStart,
  onTouchEnd,
}) {
  if (!activeItem) return null;

  return (
    <div
      className="fixed inset-0 z-[120] bg-black/85 backdrop-blur-sm p-2 sm:p-3 md:p-6"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div className="flex h-full items-center justify-center">
        <div
          className="relative w-full max-w-6xl overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#131314] shadow-2xl sm:rounded-[2rem]"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            onClick={onClose}
            className="absolute right-3 top-3 z-20 flex h-11 w-11 items-center justify-center rounded-full bg-black/55 text-white hover:bg-black/75 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4B400]/60"
            aria-label="Close gallery"
          >
            ×
          </button>

          {filteredItems.length > 1 && (
            <>
              <button
                type="button"
                onClick={onPrev}
                className="absolute left-3 top-1/2 z-20 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-black/55 text-white hover:bg-[#7D192A] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4B400]/60"
                aria-label="Previous media"
              >
                ‹
              </button>
              <button
                type="button"
                onClick={onNext}
                className="absolute right-3 top-1/2 z-20 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-black/55 text-white hover:bg-[#7D192A] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4B400]/60"
                aria-label="Next media"
              >
                ›
              </button>
            </>
          )}

          <div
            className="flex min-h-[72vh] flex-col"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <div className="relative flex-1 bg-black">
              {activeItem.type === "photo" ? (
                <img
                  src={activeItem.src}
                  alt={activeItem.caption}
                  className="h-[52vh] sm:h-[62vh] md:h-[72vh] lg:h-[78vh] w-full object-contain"
                />
              ) : (
                <video
                  key={activeItem.id}
                  className="h-[52vh] sm:h-[62vh] md:h-[72vh] lg:h-[78vh] w-full object-contain bg-black"
                  controls
                  playsInline
                  preload="metadata"
                >
                  <source src={activeItem.src} type="video/mp4" />
                </video>
              )}
            </div>

            {filteredItems.length > 1 && (
              <div className="border-t border-white/10 bg-[#131314] px-4 py-4 sm:px-5 md:hidden">
                <div className="flex items-center justify-center gap-2">
                  <button
                    type="button"
                    onClick={onPrev}
                    className="flex h-11 w-11 items-center justify-center rounded-full bg-white/8 text-white hover:bg-white/14 transition-colors"
                    aria-label="Previous media"
                  >
                    ‹
                  </button>
                  <button
                    type="button"
                    onClick={onNext}
                    className="flex h-11 w-11 items-center justify-center rounded-full bg-white/8 text-white hover:bg-white/14 transition-colors"
                    aria-label="Next media"
                  >
                    ›
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
